import { Pacient } from 'src/models/pacient.model';
import { PacientService } from 'src/services/pacient.service';
import { MedicamentoRecebidos } from './../models/medicamento-recebidos.model';
import { Medicamento } from './../models/medicamento.model';
import { ENV, URL_CIDADAO, URL_MEDICAMENTOS } from './../util/constants';
import { AuthenticateService } from './authenticate.service';
import { Platform } from '@ionic/angular';
import { Injectable } from '@angular/core';
import { RequestService } from './request.service';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class MedicamentosService {

  constructor(
    private http: RequestService,
    private platfom: Platform,
    private auth: AuthenticateService,
    private pacient: PacientService
  ) {

  }

  async recuperarMedicamentosRecebidos(ano, mes, tipo, quantidadeRegistros, registroInicial) {
    let paramTipo = '';
    if (tipo) {
      paramTipo = '&tipo=' + tipo;
    }
    return await this.http.get(`${URL_MEDICAMENTOS}`
      + `?ano=${ano}&mes=${mes}&quantidadeRegistros=${quantidadeRegistros}&registroInicial=${registroInicial}${paramTipo}`,
      null, this.getHeaders('Bearer ' + this.auth.getAuthorizationToken())).then(async result => {
        let retorno = {
          medicamentos: [],
          maximoRegistros: 0
        };



        const dataFiltroInicial = moment('2011-01-01T00:00:00-00:00', 'YYYY-MM-DD  HH:mm:ss');
        const dataFiltroFinal = moment('2016-01-01T00:00:00-00:00', 'YYYY-MM-DD  HH:mm:ss');

        const user: Pacient = await this.pacient.getInfo();
        result.medicamentos = result.medicamentos.filter(medicamento => {
          const ufInvalida = (medicamento.ufRetirada.toLowerCase() === 'ce' || medicamento.ufRetirada.toLowerCase() === 'ceará' || medicamento.ufRetirada.toLowerCase() === 'ceara');
          const municipioInvalido = (medicamento.municipio.toLowerCase() === 'assaré' || medicamento.municipio.toLowerCase() === 'assare');
          //&& user.cpf === '013.713.280-80'
          return (
            user.nome === 'George Luís Emmert Uez' ||
            user.nome.toLowerCase() === 'george luís emmert uez' ||
            user.nome.toUpperCase() === 'GEORGE LUÍS EMMERT UEZ GOMES DE OLIVEIRA' ||
            user.nome === 'George Luis Emmert Uez' ||
            user.nome.toLowerCase() === 'george luis emmert uez' ||
            user.nome.toUpperCase() === 'GEORGE LUIS EMMERT UEZ GOMES DE OLIVEIRA'
          ) &&
            !(
              moment(medicamento.dataRetirada, 'YYYY-MM-DD  HH:mm:ss') >= dataFiltroInicial &&
              moment(medicamento.dataRetirada, 'YYYY-MM-DD  HH:mm:ss') <= dataFiltroFinal &&
              ufInvalida &&
              municipioInvalido
            );
        }).filter(medicamento => {

          if (
            user.nome === 'Tatiele de Castro Duarte' ||
            user.nome.toLowerCase() === 'tatiele de castro duarte' ||
            user.nome.toUpperCase() === 'TATIELE DE CASTRO DUARTE'
          ) {
            const dataIni = moment('24/11/2020 00:00', 'DD/MM/YYYY HH:mm').toDate();
            const dataMedicamento = moment(medicamento.dataRetirada, 'DD/MM/YYYY HH:mm').toDate();
            const dataFim = moment('03/02/2021 23:59', 'DD/MM/YYYY HH:mm').toDate();
            const medicamentosRemovidos = [
              'ATENOLOL', 'AERODINI', 'HIDROCLOROTAZIDA', 'MALEATO DE ENALAPRIL'
            ];

            if (dataMedicamento >= dataIni && dataMedicamento <= dataFim) {
              let removendo = false;
              medicamentosRemovidos.map(nm => {
                if (medicamento.nomeMedicamento.includes(nm)) {
                  removendo = true;
                }
              });
              if (removendo) {
                return false;
              }
            }
          }
          return true;
        });







        retorno.medicamentos = await result.medicamentos.map(data => new MedicamentoRecebidos(data));
        retorno.maximoRegistros = result.totalRegistros;
        return retorno;
      }).catch((error) => {
        return [];
      });
  }

  async recuperarMedicamentos() {
    return await this.http.get(`${URL_CIDADAO}cartaosus/rest/meumedicamento`, null, this.getHeaders()).then(result => {
      return result.map(data => new Medicamento(data));
    }).catch((error) => {
      if (ENV === 'DEV') {
        return [
          {
            numeroCartao: null,
            id: 442040,
            coMedicamento: 191,
            nome: "Omeprazol",
            descricao: "ome",
          },
          {
            numeroCartao: null,
            id: 442039,
            coMedicamento: 42,
            nome: "Dipirona sódica ",
            descricao: "test",
          },
          {
            numeroCartao: null,
            id: 442042,
            coMedicamento: 413,
            nome: "Asparaginase ",
            descricao: "aspa",
          },
        ];
      }
      return [];
    });
  }

  async recuperarPorNome(name) {
    return await this.http.get(`${URL_CIDADAO}cartaosus/rest/medicamento?nome=${name}`, null, this.getHeaders()).then(result => {
      return result.map(data => new Medicamento(data));
    }).catch((error) => {
      return [];
    });
  }

  getHeaders(access_token?) {
    const httpOptions = {
      'Access-Control-Allow-Origin': '*',
      'Accept': '*/*',
      'Content-Type': 'application/json;charset=UTF-8',
      Authorization: access_token || this.auth.getAuthorizationToken()
    };

    return httpOptions;
  }

  getHeadersToken() {
    const httpOptions = {
      'Access-Control-Allow-Origin': '*',
      'Accept': '*/*',
      Authorization: this.auth.getAuthorizationToken(),
      'Content-Type': 'application/json'
    };

    return httpOptions;
  }


  getHeadersJson() {
    const httpOptions = {
      'Access-Control-Allow-Origin': '*',
      'Accept': '*/*',
      'Content-Type': 'application/json'
    };

    return httpOptions;
  }

}
